import formatDate from "../utils/formatDate";
import capitalizeWords from "./firstLetterCapital";

const formatKeys = (keys) => {
  if ([null, undefined, ""].includes(keys)) {
    return "--";
  }

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(keys)) {
    return formatDate(keys);
  }

  if (typeof keys === "object" && Array.isArray(keys)) {
    if (keys.length === 0) {
      return "--";
    }
    return keys.join(", ");
  }

  if (typeof keys === "boolean") {
    if (keys === true) {
      return "true"
    }
    return "false"
  }

  if (["Kg i A", "Kg i a", "Kg i b", "Kg i B", "Kg ii A", "Kg ii a", "Kg ii b", "Kg ii B", "I a", "I b", "Ii a", "Ii b", "Iii a", "Iii b", "Iv a", "Iv b", "V a", "V b", "Vi a", "Vi b", "Vii a", "Vii b", "Viii a", "Viii b", "Ix a", "Ix b", "X a", "X b",].includes(keys)) {
    return keys.toUpperCase();
  }

  if (['Nursery a', 'Nursery b'].includes(keys)) {
    return capitalizeWords(keys);
  }

  return keys;
};

export default formatKeys;
